<template>
    <div class="page">
        <div class="ab-footer">
            <div class="ab-wrapper">
                <div
                    id="ab-quicklinks"
                    class="goa-list"
                >
                    <h3 class="sr-only">
                        Quick links
                    </h3>
                    <ul>
                        <li><a href="https://www.alberta.ca/find-a-job">Jobs</a></li>
                        <li><a href="https://www.alberta.ca/staff-directory.cfm">Staff directory</a></li>
                        <li><a href="https://www.alberta.ca/open-government-program">Open government</a></li>
                        <li><a href="https://www.alberta.ca/ministries">Ministries</a></li>
                        <li><a href="https://www.alberta.ca/contact-government">Contact us</a></li>
                        <li><a href="https://www.alberta.ca/social-media-directory">Social media</a></li>
                    </ul>
                </div>

                <div
                    id="ab-aboutlinks"
                    class="goa-list"
                >
                    <h3 class="sr-only">
                        About this site
                    </h3>
                    <ul>
                        <li><a href="https://www.alberta.ca/usingthissite">Using Alberta.ca</a></li>
                        <li><a href="https://www.alberta.ca/disclaimer">Disclaimer</a></li>
                        <li><a href="https://www.alberta.ca/privacystatement">Privacy</a></li>
                        <li><a href="https://www.alberta.ca/accessibility">Accessibility</a></li>
                    </ul>
                </div>

                <div class="ab-copyright">
                    © 2024 Government of Alberta
                </div>
                <span class="ab-logo">Home</span>
            </div>
        </div>
    </div>
</template>
